export const uniqueObjArray = <T extends Record<string, any>>(
	objArray: T[],
	uniqueKey: string
) => [
	...(new Map(objArray.map(item => [item[uniqueKey], item])) as any).values()
];
